export enum MetricCategory {
  NORTHBEAM = "Northbeam",
  FORECASTED_NORTHBEAM = "Forecasted Northbeam",
  LTV = "LTV",

  SUBSCRIPTION = "Subscription metrics",

  FACEBOOK = "Facebook reported",
  TIK_TOK = "TikTok reported",
  GOOGLE = "Google reported",
  YOU_TUBE = "YouTube",
  SNAPCHAT = "Snapchat reported",
  PINTEREST = "Pinterest reported",
  TWITTER = "Twitter reported",
  TRADEDESK = "Trade Desk reported",
}

export interface MetricConfig {
  id: string;
  name: string;
  visible: boolean;
  isNonModal?: boolean;
}

export interface ColumnConfig extends MetricConfig {
  width: number;
}

export type CategoryGroupedConfig<T extends MetricConfig> = Record<
  MetricCategory,
  T[]
>;

// TODO: Figure out a better way to create categories
const metricCategoryFilter: Record<
  MetricCategory,
  (config: MetricConfig) => boolean
> = {
  [MetricCategory.NORTHBEAM]: ({ name, metric }: any) =>
    !(
      name.toLowerCase().includes("ltv") ||
      name.toLowerCase().includes("forecasted") ||
      name.toLowerCase().includes("fb ") ||
      name.toLowerCase().includes("google ") ||
      (name.toLowerCase().includes("tiktok ") &&
        metric?.composition.type !== "base") ||
      name.toLowerCase().includes("subscription") ||
      name.toLowerCase().includes("snapchat ") ||
      name.toLowerCase().includes("pinterest ") ||
      name.toLowerCase().includes("twitter ") ||
      name.toLowerCase().includes("trade desk")
    ),
  [MetricCategory.FORECASTED_NORTHBEAM]: ({ name }) =>
    name.toLowerCase().includes("forecasted"),
  [MetricCategory.LTV]: ({ name }) => name.toLowerCase().includes("ltv"),
  [MetricCategory.SUBSCRIPTION]: ({ name }) =>
    name.toLowerCase().includes("subscription"),

  [MetricCategory.FACEBOOK]: ({ name }) => name.toLowerCase().includes("fb "),
  [MetricCategory.TIK_TOK]: ({ name, metric }: any) =>
    metric?.composition.type !== "base" &&
    name.toLowerCase().includes("tiktok "),
  [MetricCategory.SNAPCHAT]: ({ name }) =>
    name.toLowerCase().includes("snapchat "),
  [MetricCategory.PINTEREST]: ({ name }) =>
    name.toLowerCase().includes("pinterest "),
  [MetricCategory.GOOGLE]: ({ name }) => name.toLowerCase().includes("google "),
  [MetricCategory.YOU_TUBE]: () => false,
  [MetricCategory.TWITTER]: ({ name }) =>
    name.toLowerCase().includes("twitter "),
  [MetricCategory.TRADEDESK]: ({ name }) =>
    name.toLowerCase().includes("trade desk"),
};

export const createMetricCategories = <T extends MetricConfig>(
  configs: T[],
) => {
  return Object.values(MetricCategory).reduce<CategoryGroupedConfig<T>>(
    (acc: CategoryGroupedConfig<T>, category: string) => {
      acc[category as MetricCategory] = configs.filter(
        metricCategoryFilter[category as MetricCategory],
      );
      return acc;
    },
    {} as CategoryGroupedConfig<T>,
  );
};
